function formatEpisodeDuration(seconds) {
  let time = new Date(seconds * 1000).toISOString().slice(11, 19);
  if (time.startsWith('00:')) {
    time = time.slice(3);
  }
  return time;
}

export default function getDuration(episode) {
  if (episode.itunes.duration != 0) {
    // it's in seconds
    return formatEpisodeDuration(episode.itunes.duration);
  }
  return formatEpisodeDuration(0)
}
